import { useNavigate } from "react-router-dom";
import "./styles.scss";
import { toast } from "react-toastify";
import { useQueryClient } from "@tanstack/react-query";
import LogoAdDesk from "@/assets/images/logo-adDesk.svg";
import MascoteError from "@/assets/images/mascote.webp";
import IconButtonBack from "@/assets/images/icon-button-back.svg";
import IconExit from "@/assets/images/icon-exit.svg";

export default function ErrorRouter() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const handleHome = () => {
    navigate(-1);
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("dados");
    navigate("/login");
    toast.success("Deslogado com Sucesso!");
    queryClient.clear(); // Limpa o cache do React Query
  };

  return (
    <div className="pt-7 sm:pt-0 h-screen flex justify-center items-center">
      <div className="container lg:!max-w-[1244px] mx-auto">
        <div className="space-y-7">
          <div className="flex justify-center items-center">
            <img src={LogoAdDesk} alt="Logo AdDesk" />
          </div>
          <div className="rounded-3xl sm:rounded-[6rem] shadow-lg overflow-hidden">
            <div
              className="bg-gradient-to-r from-[#153ECE] to-[#5E82FF] flex justify-between items-center relative
             G px-4 sm:px-16 pt-10 pb-32  sm:pb-8 md:pb-4 lg:pb-0"
            >
              <div className="flex-1 space-y-3 sm:space-y-7">
                <h2 className="text-white text-lg sm:text-4xl md:text-5xl lg:text-7xl font-medium">
                  Não foi possível <br /> carregar essa página
                </h2>
                <p className="text-white text-sm sm:text-lg md:text-xl lg:text-2xl">
                  Parece que ocorreu um problema inesperado. Você pode tentar
                  voltar para a página anterior ou sair e voltar à página
                  inicial.
                </p>
                <div className="absolute sm:static bottom-4 sm:flex sm:items-center sm:gap-4 space-y-3 sm:space-y-0">
                  <button
                    onClick={handleHome}
                    className="bg-white text-[#153ECE] px-5 py-3 lg:text-xl text-xs sm:text-base shadow-lg 
                    rounded-full flex items-center gap-2
                    transition-all duration-300 ease-in-out
                    hover:scale-105 hover:shadow-xl
                    active:scale-95
                   "
                  >
                    <img
                      src={IconButtonBack}
                      alt="Icon Button Back"
                      className="transition-transform duration-300 hover:translate-x-[-4px]"
                    />
                    Voltar para página anterior
                  </button>
                  <button
                    onClick={handleLogout}
                    className="border border-white shadow-lg
                     text-white lg:text-xl text-xs sm:text-base px-5 py-3 rounded-full 
                     hover:bg-white/10 transition-all duration-300 
                     flex items-center gap-2
                     hover:scale-105 hover:shadow-xl
                     active:scale-95
                     "
                  >
                    <img
                      src={IconExit}
                      alt="Icon Exit"
                      className="transition-transform duration-300 hover:rotate-12 w-3 sm:w-auto"
                    />
                    Exit
                  </button>
                </div>
              </div>
              <div className="w-1/2 sm:w-1/3 lg:w-auto">
                <img src={MascoteError} alt="Mascote Error" />
              </div>
            </div>
            <div className="flex justify-center items-center py-5 sm:py-7 md:py-10 bg-white">
              <p className="text-[#153ECE] text-base sm:text-xl md:text-2xl">
                ERRO 404 • AJUDA
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
